import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Lock } from "lucide-react";
import { toast } from "sonner";

export default function AdminLogin() {
    const { admin, login } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState("admin@vedicvisionaries.com");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    if (admin) return <Navigate to="/admin" replace />;

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const r = await login(email, password);
        setLoading(false);
        if (r.ok) {
            toast.success("Welcome back, Dr. Tannu!");
            navigate("/admin");
        } else {
            toast.error(r.error);
        }
    };

    return (
        <div data-testid="admin-login-page" className="min-h-screen pt-32 pb-20">
            <div className="container-vv max-w-md">
                <div className="card-luxe">
                    <div className="h-14 w-14 rounded-full bg-gold/10 border border-gold/30 grid place-items-center mx-auto mb-5">
                        <Lock className="h-6 w-6 text-gold" />
                    </div>
                    <h1 className="font-serif text-3xl text-cream text-center">Admin Sign In</h1>
                    <p className="text-cream-muted text-center text-sm mt-2">Dashboard access for Dr. Tannu &amp; team</p>

                    <form onSubmit={submit} className="mt-8 space-y-4">
                        <div>
                            <label className="text-xs tracking-widest uppercase text-cream-muted">Email</label>
                            <input type="email" className="input-luxe mt-2" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email" />
                        </div>
                        <div>
                            <label className="text-xs tracking-widest uppercase text-cream-muted">Password</label>
                            <input type="password" className="input-luxe mt-2" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password" />
                        </div>
                        <button type="submit" disabled={loading} className="btn-gold w-full disabled:opacity-50" data-testid="admin-login-btn">
                            {loading ? "Signing in..." : "Sign In"}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}
